import {
  Directive, ElementRef, OnInit, OnDestroy,
  AfterContentInit
} from '@angular/core';
import {Subscription} from "rxjs";
import {filter} from "rxjs/operators";

import {LayoutService} from "../../layout/layout.service";
import {Router, NavigationEnd} from "@angular/router";

declare var $:any;

@Directive({
    selector: '[saSmartMenu]',
    standalone: false
})
export class SmartMenuDirective implements OnInit, AfterContentInit, OnDestroy {

  private $menu:any;
  private layoutSub:Subscription;
  private routerSub:Subscription;

  constructor(
    private menu:ElementRef,
    private router: Router,
    public layoutService:LayoutService
  ) {
    this.$menu = $(this.menu.nativeElement);
  }

  ngOnInit() {

    this.layoutSub = this.layoutService.subscribe((store)=> {
      this.processLayout(store)

    });

    this.routerSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        setTimeout(() => {
          this.processLayout(this.layoutService.store);
        }, 1);
      });

    $('[routerLink]', this.$menu).on('click',()=>{
      if(this.layoutService.store.mobileViewActivated){
        this.layoutService.onCollapseMenu()
      }
    })

  }


  ngAfterContentInit() {
    this.$menu.find('li:has(> ul)').each((i, li)=> {
      let $menuItem = $(li);
      let $a = $menuItem.find('>a');
      let sign = $('<b class="collapse-sign"><em class="fa fa-plus-square-o"/></b>');
      $a.on('click', (e)=> {
        this.toggle($menuItem);
        e.stopPropagation();
        return false;
      }).append(sign);
    });
  }

  ngOnDestroy() {
    this.layoutSub.unsubscribe();
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }

  private processLayout = (store)=>{
    if (store.menuOnTop) {
      this.$menu.find('li.open').each((i, li)=> {
        this.toggle($(li), false, false)
      })
    } else {
      // Collect the parents that should be open
      let $activeParents = this.$menu.find('li.active').parents('li');
      // Close sections that are open but shouldn't be
      this.$menu.find('li.open').each((i, li)=> {
        if (!$activeParents.is(li)) {
          this.toggle($(li), false, false)
        }
      });
      // Open parents of the currently active item
      $activeParents.each((i, parentLi)=>{
        this.toggle($(parentLi), true, false)
      })
    }

    if(store.mobileViewActivated){
      $('body').removeClass("minified");
    }
  };

  private toggle($el, condition = !$el.data('open'), animate = true) {
    if ($el.data('open') === condition) {
      return;
    }

    $el.toggleClass('open', condition);

    let $ul = $el.find('>ul');
    $ul.stop(true, true);
    if(condition){
      animate ? $ul.slideDown() : $ul.show();
    } else {
      animate ? $ul.slideUp() : $ul.hide();
    }

    $el.find('>a>.collapse-sign>em')
      .toggleClass('fa-plus-square-o', !condition)
      .toggleClass('fa-minus-square-o', condition);

    $el.data('open', condition);

    if (condition) {
      $el.siblings('.open').each((i, it)=> {
        let sib = $(it);
        this.toggle(sib, false, animate)
      })
    }
  }

}
